/*
 CruiseCardsManager Module

 */

import CruiseCards from './objects/cruiseCards.js'
import DetailApiManager from './detailApiManager'

const CruiseCardsManager = (function(CruiseCards, DetailApiManager) {
    // ================== VARIABLE ================== //
    var _thumb_data = {};
    var _currentBaseResult;
    var _firstTime = true;

    var _mainContainer;
    var _otherTypeTitle;
    var _otherTypeContainer;
    var _otherProposalTitle;
    var _otherProposalContainer;

    // ================== CONSTRUCTOR ================== //
    function CruiseCardsManager() {
        // Singleton
        if (CruiseCardsManager.instance) {
            throw new Error('CruiseCardsManager is a singleton. Use CruiseCardsManager.instance.');
        }
        // enforces new
        if (!(this instanceof CruiseCardsManager)) {
            return new CruiseCardsManager();
        }

        _mainContainer = $('#cards-container');
        _otherTypeTitle = $("#other-type-title");
        _otherTypeContainer = $("#other-type-container");
        _otherProposalTitle = $("#other-proposal-title");
        _otherProposalContainer = $("#other-proposal-container");
    };

    // ================== PUBLIC METHOD ================== //

    /**
    Reset all cards and empty containers.
    Usefull when departure_date parameter changes and all cruises data
    have to be recomputed server-side
    */
    CruiseCardsManager.prototype.reset = function() {
        DetailApiManager.reset()
        _thumb_data = {}
        _currentBaseResult = undefined
        _mainContainer.html('')
        _otherTypeContainer.html('')
        _otherProposalContainer.html('')
    }

    CruiseCardsManager.prototype.displayFirstResult = function(base_result, sharing_type) {
        _addThumbToContainer(base_result, sharing_type, _mainContainer);
        _currentBaseResult = base_result;
    };

    /**
     * Display all result based on sharing type.
     * @param {Object[]} base_result - The list of cruise to be display
     * @param {Object} other_result - The lists of other cruise result to be display
     * @param {Object[]} other_result.other_type - other type cruise list
     * @param {Object[]} other_result.other_dates - other dates cruise list
     * @param {Object[]} other_result.other_destination - other destination cruise list
     * @param {string} sharing_type - In witch sharing type, thumb should be display (usefull for price)
     */
    CruiseCardsManager.prototype.displayAllResult = function(base_result, other_result, sharing_type) {
        //_hideList(_currentBaseResult);
        _displayBase(base_result, sharing_type);
        _displayOtherType(other_result.other_type, (sharing_type == 'private' ? 'shared' : 'private'));
        _displayOtherProposal(other_result.other_dates, other_result.other_destination, sharing_type);
        //_currentBaseResult = base_result;
    };

    /**
     * Display only base result based on sharing type. Also hide old base result
     * @param {Object[]} base_result - The list of cruise to be display
     * @param {string} sharing_type - In witch sharing type, thumb should be display (usefull for price)
     */
    CruiseCardsManager.prototype.displayBaseResult = function(base_result, sharing_type) {
        _hideList(_currentBaseResult);
        _addThumbToContainer(base_result, sharing_type, _mainContainer);
        if(base_result !== undefined) {
          _orderContainer(_mainContainer, base_result);
        }
        _currentBaseResult = base_result;
    };

    // ================== PRIVATE METHOD ================== //

    // Display base result, Also hide thumb that are not in base_result.
    function _displayBase(base_result, sharing_type) {
        for (var key in _thumb_data) {
            if (!_isInList(_thumb_data[key].id, base_result)) {
                _thumb_data[key].hide();
            }
        }
        _addThumbToContainer(base_result, sharing_type, _mainContainer);
        _orderContainer(_mainContainer, base_result);
        _currentBaseResult = base_result;
    }

    // Display other type result (also manage display of title).
    function _displayOtherType(other_type, sharing_type) {
        if (other_type != 0) {
            _otherTypeTitle.show();
            _addThumbToContainer(other_type, sharing_type, _otherTypeContainer);
            _otherTypeContainer.show();
        } else {
            _otherTypeTitle.hide();
            _otherProposalContainer.hide();
        }
    }

    // Display other proposal (Dates and Destination).
    function _displayOtherProposal(other_dates, other_destination, sharing_type) {
        if (other_dates.length != 0 || other_destination.length != 0) {
            _otherProposalTitle.show()
            _otherProposalContainer.show();
            _addThumbToContainer(other_dates, sharing_type, _otherProposalContainer);
            _addThumbToContainer(other_destination, sharing_type, _otherProposalContainer);
        } else {
            _otherProposalTitle.hide();
            _otherProposalContainer.hide();
        }
    }

    // Add or create thumb in the container.
    function _addThumbToContainer(cruise_list, sharing_type, container) {
        if(cruise_list === undefined) {
           return
        }
        var thumb_id;
        for (var i = 0; i < cruise_list.length; i++) {
            thumb_id = 'id_' + cruise_list[i].id;
            if (_thumb_data[thumb_id] == undefined) {
                _thumb_data[thumb_id] = new CruiseCards(
                    cruise_list[i].id, cruise_list[i].duration, cruise_list[i].is_best_sale,
                    sharing_type, container);
            } else {
                _thumb_data[thumb_id].show(sharing_type, container);
            }
        }
    }

    // Check if the given id is in list.
    function _isInList(id, list) {
        for (var i = 0; i < list.length; i++)
            if (list[i].id === id)
                return true;
        return false;
    }

    // Hide all thumb in the given list
    function _hideList(list) {
        for (var key in _thumb_data) {
            if (_isInList(_thumb_data[key].id, list)) {
                _thumb_data[key].hide();
            }
        }
    }

    // Order thumb in the given container, based on the base_result list ( who is ordered ).
    function _orderContainer(container, base_result) {
        // Since base result is ordered, we find the index of the id in it.
        function indexOf(id) {
            for (var i = 0; i < base_result.length; i++) {
                if (base_result[i].id == id)
                    return i;
            }
        }

        container.append(container.contents().sort(
            function(a, b) {
                var A = a.id != undefined ? indexOf(a.id.slice(6)) : 0;
                var B = b.id != undefined ? indexOf(b.id.slice(6)) : 0;
                return A - B;
            }
        ));
    }

    CruiseCardsManager.instance = new CruiseCardsManager();

    return CruiseCardsManager.instance;
})(CruiseCards, DetailApiManager);

export default CruiseCardsManager



// WEBPACK FOOTER //
// ./search/static/search/js/cruiseCardsManager.js